import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type ToggleAnnouncementInput = {
  id: string;
  active: boolean;
};

// PATCH /api/settings/announcements/:id
//
// Flips the `active` column. Replaces revalidatePath("/admin/settings") +
// revalidatePath("/portal/dashboard") — the inbox strip re-reads visibility
// when this fires.
export function useToggleAnnouncement() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, ToggleAnnouncementInput>({
    mutationFn: ({ id, active }) =>
      apiFetch<{ ok: true }>(`/settings/announcements/${id}`, {
        method: "PATCH",
        body: JSON.stringify({ active }),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.announcements() });
      queryClient.invalidateQueries({ queryKey: queryKeys.notifications.inbox() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to toggle announcement");
    },
  });
}
